module.exports = __webpack_public_path__ + "static/media/arrow-return.45327683.svg";